module.exports = __webpack_public_path__ + "static/media/PorCobrar.c8b12eba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/PorCobrar.svg
// module id = 626
// module chunks = 32